import { ReportCreateBody } from '../../store/report/create';
import {
    DefaultFetchError,
    FetchCreate,
    FetchSuccess,
    useFetchCreate,
} from '../fetch';


export const useReportCreate = (): FetchCreate<FetchSuccess, DefaultFetchError, ReportCreateBody> => (
    useFetchCreate('reports', { autoStart: false, startStateLoading: false })
)
